exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#line-chart {\n  max-height: 30vh;\n}\n\n.alert.alert-warning {\n  margin-bottom: 40px;\n}\n\n.stat-container {\n  width: 70%;\n  margin: auto;\n  margin-bottom: 40px;\n}\n\n.users-container {\n  width: auto !important;\n  margin: 20px 24px 0 24px;\n}\n\n.p-24 {\n  padding: 24px;\n}", ""]);

